
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "58da1142-a02a-4886-a0a7-e10b27b63e20"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/builds/sites/wnhub-general-client/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
